import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=111dec1b&"
import script from "./BaseSnackbar.vue?vue&type=script&lang=ts&"
export * from "./BaseSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=111dec1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports